import { createMultiStyleConfigHelpers, ComponentStyleConfig } from '@chakra-ui/react';
import { breadcrumbAnatomy } from '@chakra-ui/anatomy';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(breadcrumbAnatomy.keys);

const baseStyle = definePartsStyle({
  link: {
    color: 'link-color',
    fontWeight: 'medium',

    _hover: {
      color: 'link-hover-color',
    },

    _focus: {
      color: 'link-hover-color',
    },

    _active: {
      color: 'link-active-color',
    },
  },
});

export const breadcrumbTheme: ComponentStyleConfig = defineMultiStyleConfig({
  baseStyle,
});
